var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagsForms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66732 1.88867V5.33079C9.66732 5.7975 9.66732 6.03085 9.75815 6.20911C9.83804 6.36592 9.96552 6.4934 10.1223 6.57329C10.3006 6.66412 10.5339 6.66412 11.0007 6.66412H14.4428M11.334 10.8307H4.66732M11.334 14.1641H4.66732M6.33398 7.4974H4.66732M9.66732 1.66406H5.33398C3.93385 1.66406 3.23379 1.66406 2.69901 1.93655C2.2286 2.17623 1.84615 2.55868 1.60647 3.02909C1.33398 3.56387 1.33398 4.26393 1.33398 5.66406V14.3307C1.33398 15.7309 1.33398 16.4309 1.60647 16.9657C1.84615 17.4361 2.2286 17.8186 2.69901 18.0582C3.23379 18.3307 3.93385 18.3307 5.33398 18.3307H10.6673C12.0674 18.3307 12.7675 18.3307 13.3023 18.0582C13.7727 17.8186 14.1552 17.4361 14.3948 16.9657C14.6673 16.4309 14.6673 15.7309 14.6673 14.3307V6.66406L9.66732 1.66406Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsForms);
export default __webpack_public_path__ + "static/media/tags-forms.fc1a5c311836721ea05108ed3116c213.svg";
export { ForwardRef as ReactComponent };